import { StateInterface } from "./state";

export default {
  loaded(state: StateInterface): void {
    state.loaded = true;
  }
};
